import { Component } from '@angular/core';

@Component({
  selector: 'app-link-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './link-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class LinkIconComponent {}
